
  export default {
    mounted() {
      this.frame = this.el.querySelector("iframe")
      this.box = this.el.querySelector("[data-frame-box]")
      this.frameWidth = Number(this.el.dataset.frameWidth)
      this.layout = this.layout.bind(this)
      this.stageObserver = new ResizeObserver(this.layout)
      this.stageObserver.observe(this.el)
      this.frame.addEventListener("load", () => {
        const doc = this.frame.contentDocument
        if (doc) {
          this.contentObserver = new ResizeObserver(this.layout)
          this.contentObserver.observe(doc.body)
        }
        this.layout()
      })
    },

    layout() {
      const style = getComputedStyle(this.el)
      const available =
        this.el.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight)
      const scale = Math.min(1, available / this.frameWidth)
      const doc = this.frame.contentDocument
      const height = doc ? doc.body.scrollHeight : this.frame.offsetHeight

      this.frame.style.height = `${height}px`
      this.frame.style.transform = `scale(${scale})`
      this.box.style.width = `${this.frameWidth * scale}px`
      this.box.style.height = `${height * scale}px`
    },

    destroyed() {
      this.stageObserver?.disconnect()
      this.contentObserver?.disconnect()
    }
  }
